// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"547b3223","353":"a99325c2"}[chunkId] + ".js";
};